import { render } from "./CreateQuestionModal.vue?vue&type=template&id=afbdae1e&scoped=true"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=js"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=js"

import "./CreateQuestionModal.vue?vue&type=style&index=0&id=afbdae1e&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbdae1e"]])

export default __exports__